export default {
    enable: Boolean,
    index: Number,
    selection: String,

    // Events
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButtonGroup/ButtonGroupProps.js